import React from "react";
import { Select, Row, Col } from "antd";
import { connect } from "react-redux";
import CustomRadioGroup from "components/fragments/custom-radio/CustomRadioGroup";
import { AUSTRALIAN_STATES } from "utils/referenceData";
import SvgMapSelect from "components/fragments/svg-map-select/SvgMapSelect";
import { ACTION_TYPES } from "reducers/actionTypes";
import "assets/stylesheets/SelectState.scss";

class SelectState extends React.Component {
  componentDidUpdate = (prevProps) => {
    if (!prevProps.focusSelect && this.props.focusSelect) {
      this.selectState.focus();
    }
  };

  handleStateChange = (stateValue) => {
    const { activeState, dispatch } = this.props;
    if (stateValue !== activeState) {
      dispatch({ type: ACTION_TYPES.subjects.reset });
    }

    dispatch({
      type: ACTION_TYPES.state.update,
      data: { activeState: stateValue },
    });
    if (stateValue !== "NSW") {
      this.handleKnowAtarChange(false);
    }
  };

  handleKnowAtarChange = (value) => {
    this.props.dispatch({
      type: ACTION_TYPES.state.update,
      data: { knowAtar: value },
    });
  };

  render() {
    const { activeState, knowAtar } = this.props;

    return (
      <section className="section">
        <Row>
          <Col sm={24} md={12}>
            <h2 className="section-card-title" tabIndex={0}>
              1. Your state or territory
            </h2>
            <label
              htmlFor="select-state-input"
              className="fineprint"
              style={{ marginBottom: 20, lineHeight: "26px" }}
            >
              Select the state or territory in which you completed Year 12
            </label>
            <Select
              id="select-state-input"
              defaultValue={activeState}
              onChange={this.handleStateChange}
              value={activeState}
              size="large"
              style={{ marginBottom: 20, minWidth: 240 }}
              placeholder={"Select state or territory"}
              ref={(input) => {
                this.selectState = input;
              }}
            >
              {AUSTRALIAN_STATES.map((o) => (
                <Select.Option value={o.id} key={o.id}>
                  {o.name}
                </Select.Option>
              ))}
            </Select>
            {activeState === "NSW" && (
              <CustomRadioGroup
                name="ATAR"
                legend="ATAR"
                value={knowAtar}
                onClickRadio={this.handleKnowAtarChange}
                choices={[
                  {
                    id: true,
                    label: "I know my ATAR",
                    value: true,
                    ariaLabel: "I know my ATAR option",
                  },
                  {
                    id: false,
                    label: "I don't know my ATAR",
                    value: false,
                    ariaLabel: "I don't know my ATAR option",
                  },
                ]}
              />
            )}
          </Col>
          <Col sm={24} md={12}>
            <div className="svg-map-select-container">
              <SvgMapSelect handleStateChange={this.handleStateChange} />
            </div>
          </Col>
        </Row>
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  const { activeState, knowAtar, focusSelect } = store.selectStateReducer;

  return {
    activeState,
    knowAtar,
    focusSelect,
  };
};

export default connect(mapStateToProps)(SelectState);
